import React, { memo, useMemo } from 'react';

import { Card, Divider } from '@/components';
import { useIsDesktop } from '@/hooks/useIsDesktop';
import { FCupTeamScore } from '@/types/friendCup';
import { formatearNumero } from '@/utils';

type Props = {
  data: FCupTeamScore | undefined;
};

export const CardPosition: React.FC<Props> = memo(({ data }) => {
  const { isDesktop } = useIsDesktop();
  const score = useMemo(() => {
    return data && data[data.length - 1].puntos;
  }, [data]);

  const position = useMemo(() => {
    return data && data[data.length - 1].posicion;
  }, [data]);

  return (
    <Card className="w-full bg-white mt-2 lg:mt-5 lg:p-0 lg:space-y-6 text-gdt-gray-4 lg:pb-7 flex lg:flex-col flex-row justify-around lg:items-start items-center px-6 py-4">
      <div className="lg:flex items-center lg:pl-[60px] pl-0">
        <p className="font-semibold text-xs lg:text-sm lg:mt-2">
          PUNTOS ACUMULADOS
        </p>
        <strong className="text-gdt-blue text-lg lg:text-2xl lg:ml-4 mt-2">
          {score ? `${formatearNumero(score)}` : '-'}
        </strong>
      </div>
      {isDesktop ? (
        <Divider type="horizontal" />
      ) : (
        <Divider className="h-10 ml-5" type="vertical" />
      )}
      <div className="lg:flex items-center lg:pl-[60px] pl-4 lg:w-auto w-[118px]">
        <p className="font-semibold text-xs lg:text-sm">POSICIÓN</p>
        <strong className="text-lg lg:text-2xl lg:ml-4 text-gdt-gray-2">
          {position ? `${formatearNumero(position)}` : '-'}
        </strong>
      </div>
    </Card>
  );
});

CardPosition.displayName = 'CardPosition';
